import { render, staticRenderFns } from "./FaqEdit.vue?vue&type=template&id=e11f55cc&"
import script from "./FaqEdit.vue?vue&type=script&lang=js&"
export * from "./FaqEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports